// extracted by mini-css-extract-plugin
export default {"text":"styles_text__x6JOe","switch":"styles_switch__yfdup"};